import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const DefaultPopperBody = ({ header, children, onClose, minWidth = '250px' }) => {
  const classes = useStyles();
  return (
    <div style={{ minWidth }} className={`${classes.bgColor}  p-3`}>
      <Card classes={{root:classes.cardContainer}}>
        <CardHeader
          classes={{ action: classes.action,root:classes.hederRoot}}
          action={
            <IconButton className={` ${classes.iconButton}`} onClick={onClose}>
              <CloseIcon />
            </IconButton>
          }
          subheader={header}
        ></CardHeader>
        <CardContent classes={{ root: classes.root }}>{children}</CardContent>
      </Card>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  bgColor: {
    backgroundColor: theme.palette.background.paper,
    // popper border radius
    borderRadius:'0px 5px 5px 0px',
    padding: '12px'
  },
  cardContainer:{
    backgroundColor: theme.palette.background.default,
  },
  root: {
    padding: '7px 5px 0px 10px !important',
  },
  iconButton: {
    '& svg': {
      width: '14px',
      height: '14px',
    }
  },
  hederRoot:{
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    margin:'0px 10px 0px 10px',
    padding:'0px',
    
  },
  action: {
    padding: '11px 2px 0px 0px',
    },
}));
export default DefaultPopperBody;
